module.exports = __webpack_public_path__ + "static/media/risk_prediction.cff31e7a.svg";